/**
 * Layout elevator component
 * 
 */

import React, { PureComponent } from 'react';

export default class Elevator extends PureComponent {

	constructor(props) {
		
		super(props);

        this.button = React.createRef();
		this.handleClick = this.handleClick.bind(this);
		this.handleScroll = this.handleScroll.bind(this);
    }

    componentDidMount() {

    	window.addEventListener('scroll', this.handleScroll);
    }

	componentWillUnmount() {
		
		window.removeEventListener('scroll', this.handleScroll);
	}

    handleScroll(event) {
    	
    	if (window.scrollY > 280) {

    		this.button.current.classList.add('show');
    	}
    	else {

    		this.button.current.classList.remove('show');
    	}
    }

    handleClick(event) {

   		window.scrollTo({ top: 0, behavior: 'smooth' });
    }

	render() {

		return <button className="layout-elevator" onClick={this.handleClick} ref={this.button}><i className="icon i-arrow-up i-3x">Back to top</i></button>;
	}
}



// WEBPACK FOOTER //
// ./src/containers/layout/elevator/elevator.js